/**
 * Backward-compatibility shim — delegates to utils/market.js.
 * Kept so existing consumers (Faq, Footer, LanguageSwitcher, TestCard, etc.)
 * keep working unchanged. New code should import from utils/market.js directly.
 */

import {
    detectMarket,
    getSlug as marketGetSlug,
    buildMarketPath,
    getMarkets,
    DEFAULT_MARKET
} from './market';

export const DEFAULT_LANG = DEFAULT_MARKET.lang;

// Legacy: list of non-default lang codes used for Polylang language switching.
// Built from the markets table (any market whose lang differs from the default
// market's lang AND has a single-segment prefix matching its lang code).
export const SUPPORTED_LANGS = getMarkets()
    .filter(m => m.prefix && m.prefix === m.lang)
    .map(m => m.lang);

export function detectLang(pathname) {
    return detectMarket(pathname).lang;
}

export function getSlug(pathname, _legacyLang) {
    // The new market-aware implementation infers the prefix itself, so the
    // second argument is ignored (kept for call-site compatibility).
    return marketGetSlug(pathname);
}

export function getLangParam(lang) {
    return `&lang=${lang}`;
}

export function buildLangUrl(targetLang, currentPath, _currentLang) {
    // Find the first market matching the target language. Prefer markets
    // whose prefix matches the lang (i.e. the "language home"), so /en/ wins
    // over /us/ when callers ask for English.
    const all = getMarkets();
    const target = all.find(m => m.lang === targetLang && m.prefix === targetLang)
        || all.find(m => m.lang === targetLang)
        || (targetLang === DEFAULT_LANG ? DEFAULT_MARKET : null);
    if (!target) {
        // Best-effort fallback if no matching market is registered.
        const slug = marketGetSlug(currentPath);
        return targetLang === DEFAULT_LANG
            ? (slug === 'home' ? '/' : `/${slug}`)
            : (slug === 'home' ? `/${targetLang}/` : `/${targetLang}/${slug}`);
    }
    return buildMarketPath(target, marketGetSlug(currentPath));
}
